<aside
  class="items absolute inset-0 box-border flex h-full max-h-full min-h-0 min-w-0 flex-col rounded-full bg-white shadow-[0_10px_28px_rgba(15,23,42,0.08)] transition-shadow duration-220 ease-[ease] lg:overflow-visible"
  [class.items-stretch]="!collapsed()"
  [class.shadow-[0_10px_28px_rgba(15,23,42,0.06)]]="collapsed()"
  [class.lg:flex-row]="!collapsed()"
  [class.max-lg:rounded-2xl]="!collapsed()"
  [class.lg:rounded-2xl]="!collapsed()"
  [class.items-center]="collapsed()"
  [class.justify-center]="collapsed()"
  [class.overflow-hidden]="collapsed()">
  <button
    type="button"
    class="toggle-handle absolute z-10 inline-flex shrink-0 cursor-pointer items-center justify-center border-0 p-0 text-[#555c66] outline-none transition-[background,color] duration-160 ease-[ease] hover:bg-[#f8f9fb] hover:text-[#252a31]"
    [ngClass]="
      collapsed()
        ? 'inset-0 h-full w-full rounded-full bg-white shadow-none'
        : 'max-lg:-top-5 max-lg:left-1/2 max-lg:h-5 max-lg:w-17 max-lg:-translate-x-1/2 max-lg:rounded-t-xl max-lg:rounded-b-none max-lg:bg-gray-100 max-lg:shadow-none lg:-left-5 lg:top-1/2 lg:h-17 lg:w-5 lg:-translate-y-1/2 lg:rounded-l-xl lg:rounded-r-none lg:bg-gray-100 lg:shadow-[-6px_4px_14px_rgba(15,23,42,0.06)]'
    "
    [attr.aria-expanded]="!collapsed()"
    [matTooltip]="(collapsed() ? labels().expandKey : labels().collapseKey) | translate"
    (click)="toggleCollapsed()">
    <mat-icon class="size-5 rotate-90 text-lg leading-4 lg:rotate-0">{{
      collapsed() ? 'chevron_left' : 'chevron_right'
    }}</mat-icon>
  </button>

  <div
    class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-(--image-list-panel-content-padding) opacity-100 transition-opacity duration-160 ease-[ease] delay-60"
    [class.max-lg:hidden]="collapsed()"
    [class.lg:pointer-events-none]="collapsed()"
    [class.lg:invisible]="collapsed()"
    [class.lg:p-0]="collapsed()"
    [class.lg:opacity-0]="collapsed()"
    [attr.inert]="collapsed() ? '' : null"
    [attr.aria-hidden]="collapsed() ? 'true' : null">
    <header class="flex shrink-0 items-center justify-between gap-1 pb-1.5 lg:gap-1">
      <div class="min-w-0 truncate text-xs font-bold text-[#15181d]">{{ labels().titleKey | translate }}</div>
      <div class="inline-flex items-center gap-0.5">
        <button
          type="button"
          class="icon-button inline-flex size-6 min-w-6 cursor-pointer items-center justify-center rounded-md border-0 bg-transparent p-0 text-[#687385] hover:enabled:bg-[#eef2f7] hover:enabled:text-[#15181d] disabled:cursor-default disabled:opacity-35"
          [disabled]="processing()"
          [matTooltip]="labels().addKey | translate"
          (click)="openFileInput()">
          <mat-icon>add_photo_alternate</mat-icon>
        </button>
      </div>
    </header>

    <input #fileInput type="file" class="hidden" accept="image/*" multiple (change)="onFilesSelected($event)" />

    @if (showEmptyState()) {
      <div class="shrink-0 pb-1 text-xs leading-4 text-[rgba(47,51,56,0.68)]">{{ labels().emptyKey | translate }}</div>
    }
    @if (items().length) {
      <div
        class="flex min-h-0 w-full max-w-full flex-1 items-stretch gap-2 overflow-x-auto overflow-y-hidden pb-0.5 lg:block lg:overflow-x-hidden lg:overflow-y-auto"
        cdkDropList
        [cdkDropListData]="items()"
        (cdkDropListDropped)="dropItem($event)">
        @for (item of items(); track trackItem($index, item); let index = $index) {
          <div
            cdkDrag
            cdkDragPreviewClass="box-border rounded-lg shadow-[0_10px_28px_rgba(15,23,42,0.22)]"
            cdkDragPlaceholderClass="opacity-20"
            [cdkDragDisabled]="!canDragItem(index)"
            class="item-row mb-0 box-border min-h-14 w-(--image-list-panel-row-width-mobile) shrink-0 cursor-default grid grid-cols-[14px_40px_minmax(0,1fr)_22px] gap-1.5 rounded-lg border border-transparent bg-white p-1 text-left text-inherit shadow-[0_1px_3px_rgba(15,23,42,0.08)] max-lg:max-h-full max-lg:overflow-hidden hover:border-[#b9c7dc] lg:mb-1.5 lg:w-[calc(var(--image-list-panel-width)-2*var(--image-list-panel-content-padding))] lg:max-h-none lg:shrink lg:overflow-visible lg:p-1"
            [class.cursor-pointer]="selectable()"
            [class.border-[rgba(47,111,237,0.24)]]="isItemLocked()(index)"
            [attr.role]="selectable() ? 'button' : null"
            [attr.tabindex]="selectable() ? 0 : null"
            (click)="selectItem(item)"
            (keydown)="onItemKeydown(item, $event)">
            <div
              class="item-drag-handle inline-flex min-h-10 w-4 cursor-grab flex-col items-center justify-center gap-0.5 text-[#98a2b3]"
              [class.cursor-default]="isItemLocked()(index)"
              cdkDragHandle>
              <mat-icon>{{ isItemLocked()(index) ? 'lock' : 'drag_indicator' }}</mat-icon>
              <span class="text-[10px] font-semibold leading-3 text-[#98a2b3]">{{ index + 1 }}</span>
            </div>

            <div
              class="item-thumb flex size-10 items-center justify-center overflow-hidden rounded-md bg-white bg-[linear-gradient(45deg,#e8eaee_25%,transparent_25%),linear-gradient(-45deg,#e8eaee_25%,transparent_25%),linear-gradient(45deg,transparent_75%,#e8eaee_75%),linear-gradient(-45deg,transparent_75%,#e8eaee_75%)] bg-size-[12px_12px] bg-position-[0_0,0_6px,6px_-6px,-6px_0]"
              aria-hidden="true">
              @if (item.previewUrl) {
                <img class="max-h-full max-w-full object-contain" [src]="item.previewUrl" alt="" />
              }
            </div>

            <div class="grid min-w-0 gap-1">
              <span class="block min-w-0 truncate text-[11px] leading-3.5 text-[#30343a]">
                @if (isItemLocked()(index) && lockedItemLabelKey(); as lockedLabelKey) {
                  {{ lockedLabelKey | translate }}
                } @else {
                  {{ item.name }}
                }
              </span>

              @if (itemMeta(); as metaTpl) {
                <ng-container [ngTemplateOutlet]="metaTpl" [ngTemplateOutletContext]="{ $implicit: item, index }" />
              }
            </div>

            <div class="item-actions inline-flex flex-col items-center gap-0.5">
              <button
                type="button"
                class="icon-button inline-flex size-6 min-w-6 cursor-pointer items-center justify-center rounded-md border-0 bg-transparent p-0 text-[#687385] hover:enabled:bg-[#eef2f7] hover:enabled:text-[#15181d] disabled:cursor-default disabled:opacity-35"
                [disabled]="!canDuplicateItem()(index)"
                [matTooltip]="labels().duplicateKey | translate"
                (click)="duplicateItem(item, index, $event)">
                <mat-icon>content_copy</mat-icon>
              </button>

              <button
                type="button"
                class="icon-button inline-flex size-6 min-w-6 cursor-pointer items-center justify-center rounded-md border-0 bg-transparent p-0 text-[#687385] hover:enabled:bg-[#feecec] hover:enabled:text-[#b42318] disabled:cursor-default disabled:opacity-35"
                [disabled]="!canDeleteItem()(index)"
                [matTooltip]="labels().deleteKey | translate"
                (click)="deleteItem(item, index, $event)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</aside>
